<div class="row">
    <!-- Manufactures -->
    <div class="col-12 col-md-3" *ngIf="showManufacturer">
        <div class="fs-6 fw-bold text-muted">
            Manufactures
            <i-bs name="infoCircle" class="text-primary" tooltip="Select a manufacturer to filter data." placement="top">
            </i-bs>
        </div>
        <select class="form-select text-muted mt-2 mb-2" [(ngModel)]="selectedManufacturer" (change)="onDropdownChange($event, 'manufacturer')">
            <option *ngFor="let manufacturer of manufactures" [value]="manufacturer.mfg_id">{{ manufacturer.mfg_name }}</option>
        </select>
    </div>

    <!-- Brands -->
    <div class="col-12 col-md-3" *ngIf="showBrand">
        <div class="fs-6 fw-bold text-muted">
            Brands
            <i-bs name="infoCircle" class="text-primary" tooltip="Select a brand to filter data." placement="top">
            </i-bs>
        </div>
        <select class="form-select text-muted mt-2 mb-2" [(ngModel)]="selectedBrand" (change)="onDropdownChange($event, 'brand')">
            <option *ngFor="let brand of brands" [value]="brand.brand_id">{{ brand.brand_name }}</option>
        </select>
    </div>

    <!-- Retailers -->
    <div class="col-12 col-md-3" *ngIf="showRetailer">
        <div class="fs-6 fw-bold text-muted">
            Retailers
            <i-bs name="infoCircle" class="text-primary" tooltip="Select a retailer to filter data." placement="top">
            </i-bs>
        </div>
        <select class="form-select text-muted mt-2 mb-2" [(ngModel)]="selectedRetailer"
            (change)="onDropdownChange($event, 'retailer')">
            <option *ngFor="let retailer of retailers" [value]="retailer.retailer_id">{{ retailer.retailer_name }}
            </option>
        </select>
    </div>

    <!-- Stores -->
    <div class="col-12 col-md-3" *ngIf="showStore">
        <div class="fs-6 fw-bold text-muted">
            Stores
            <i-bs name="infoCircle" class="text-primary" tooltip="Select a store to filter data." placement="top">
            </i-bs>
        </div>
        <select class="form-select text-muted mt-2 mb-2" [(ngModel)]="selectedStore"
            (change)="onDropdownChange($event, 'store')">
            <option *ngFor="let store of stores" [value]="store.store_id">{{ store.store_name }}</option>
        </select>
    </div>

    <!-- Date Range -->
    <div class="col-12 col-md-3" *ngIf="showCalendar">
        <div class="fs-6 fw-bold text-muted">
            Date Range
            <i-bs name="infoCircle" class="text-primary" tooltip="Select from and to dates to filter data."
                placement="top">
            </i-bs>
        </div>
        <input type="text" class="form-control text-muted  mt-2" placeholder="Select date range" bsDaterangepicker
            [bsConfig]="calendarConfig" [minDate]="calendarMinDate" [maxDate]="calendarMaxDate" [bsValue]="dateRange"
            (bsValueChange)="onCalendarValueChange($event)">
    </div>

    <!-- Coupon Source -->
    <div class="col-12 col-md-3 coupon_source_button_group" *ngIf="showCouponSource">
        <div class="fs-6 fw-bold text-muted">
            Coupon Source
            <i-bs name="infoCircle" class="text-primary" tooltip="Select type of coupon to filter coupons."
                placement="top">
            </i-bs>
        </div>
        <div class="btn-group  mt-2">
            <label [class]="couponSource === 'cpg' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'"
                btnRadio="cpg" tabindex="0" role="button" (click)="oncouponSourceChange('cpg')">Regional</label>
            <label
                [class]="couponSource === 'national' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'"
                btnRadio="national" tabindex="0" role="button"
                (click)="oncouponSourceChange('national')">National</label>
        </div>
    </div>

    <!-- Coupon Status -->
    <div class="col-12 col-md-3 coupon_source_button_group" *ngIf="showCouponStatus">
        <div class="fs-6 fw-bold text-muted">
            Coupon Status
            <i-bs name="infoCircle" class="text-primary" tooltip="Select status of coupon to filter coupons."
                placement="top">
            </i-bs>
        </div>
        <div class="btn-group mt-2">
            <label
                [class]="couponStatus === 'expired' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'"
                btnRadio="retailer" tabindex="0" role="button" (click)="oncouponStatusChange('expired')">Expired</label>
            <label
                [class]="couponStatus === 'active' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'"
                btnRadio="cpg" tabindex="0" role="button" (click)="oncouponStatusChange('active')">Active</label>
            <label
                [class]="couponStatus === 'upcoming' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'"
                btnRadio="national" tabindex="0" role="button"
                (click)="oncouponStatusChange('upcoming')">Upcoming</label>
        </div>
    </div>
</div>